/* Warm only an intended public storefront page. Normal navigation stays native. */
(() => {
  'use strict';
  const connection = navigator.connection;
  if (connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '') || window.Shopify?.designMode) return;
  const warmed = new Set();
  let timer;
  function warm(anchor) {
    if (!anchor || anchor.target || anchor.hasAttribute('download') || anchor.hasAttribute('data-enquiry-url') || warmed.size >= 4) return;
    let url;
    try { url = new URL(anchor.href, location.href); } catch { return; }
    if (url.origin !== location.origin || url.hash || (url.pathname === location.pathname && url.search === location.search)) return;
    if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:products\/[^/]+|collections\/(?!.*\/)[^/]+|pages\/[^/]+)?\/?$/i.test(url.pathname)) return;
    if ([...url.searchParams.keys()].some(key => !['rh_city','rh_q','rh_module','preview_theme_id','sort_by'].includes(key))) return;
    if (warmed.has(url.href)) return;
    warmed.add(url.href);
    const hint = document.createElement('link');
    hint.rel = 'prefetch'; hint.href = url.href; hint.as = 'document';
    document.head.append(hint);
  }
  document.addEventListener('pointerover', event => {
    if (event.pointerType !== 'mouse') return;
    clearTimeout(timer); const anchor = event.target.closest('a[href]');
    if (anchor) timer = setTimeout(() => warm(anchor), 90);
  }, { passive: true });
  document.addEventListener('pointerout', () => clearTimeout(timer), { passive: true });
  document.addEventListener('focusin', event => warm(event.target.closest('a[href]')));
  document.addEventListener('touchstart', event => warm(event.target.closest('a[href]')), { passive: true });
})();
